import React, { useState } from "react";
import PropTypes from "prop-types";

import { InvoiceService } from "@services";
import utils from "@utils";

import { Modal } from "../../../../../components";

const DownloadAttachmentsModal = ({ id, show, onClose, attachments, user }) => {
	const { lang } = global;

	const [loading, setLoading] = useState(false);

	const bulkDownload = async () => {
		try {
			setLoading(true);
			const attachmentIds = attachments.map(attachment => attachment.Id);

			await InvoiceService.downloadAllAttachments(id, attachmentIds);

			utils.notify({
				type: "success",
				message: lang.t("Attachments email sent"),
				timeOut: 1500,
			});

			onClose();
		} catch (error) {
			console.error("bulkDownload", error);
			utils.notify({
				type: "error",
				message: lang.t("Error sending email"),
			});
		} finally {
			setLoading(false);
		}
	};

	return (
		<Modal
			id="download-attachments-modal"
			show={show}
		>
			<Modal.Header>
				<Modal.Title>{lang.t("Timecard Attachments")}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<div className="row">
					<p className="col-sm-12">
						{lang.t("The link to all of these attachments will be sent to your email")}
						&nbsp;<a href={`mailto: ${user?.Email}`}>{user?.Email}</a>
					</p>
				</div>
			</Modal.Body>
			<Modal.Footer>
				<button
					type="button"
					className="btn btn-link"
					onClick={onClose}
				>
					{lang.t("Cancel")}
				</button>
				<button
					type="button"
					className="btn btn-primary"
					onClick={bulkDownload}
				>
					<Choose>
						<When condition={loading}>
							<i className="rkf rkf-spinner rkf-spin rkf-fw display-inline-block" />
						</When>
						<Otherwise>{lang.t("Send")}</Otherwise>
					</Choose>
				</button>
			</Modal.Footer>
		</Modal>
	);
};

DownloadAttachmentsModal.propTypes = {
	id: PropTypes.number.isRequired,
	show: PropTypes.bool,
	onClose: PropTypes.func,
	attachments: PropTypes.array.isRequired,
	user: PropTypes.object.isRequired,
};

DownloadAttachmentsModal.defaultProps = {
	show: false,
	onClose: () => {},
};

export default DownloadAttachmentsModal;
